import { backgroundEstimate } from './backgroundRepair.js';

/** Remove a flat backdrop from a visual group snapshot so it can be moved
 * without carrying a white/black rectangle. Never guess on complex backdrops.
 * This edits only the movable copy; the original PDF remains untouched.
 */
export function isolateFlatGroupPixels(rgba,width,height) {
  if(width<6 || height<6) return {flat:false,color:null,data:rgba};
  const estimate=backgroundEstimate(rgba,width,height,{x0:2,y0:2,x1:width-2,y1:height-2});
  if(!estimate.flat) return {flat:false,color:estimate.color,data:rgba};
  const data=new Uint8ClampedArray(rgba);
  const color=estimate.color;
  for(let k=0;k<data.length;k+=4) {
    const diff=Math.max(Math.abs(data[k]-color[0]),Math.abs(data[k+1]-color[1]),Math.abs(data[k+2]-color[2]));
    if(diff<=10) data[k+3]=0;
    else if(diff<25) data[k+3]=Math.min(data[k+3],Math.round(data[k+3]*(diff-10)/15));
  }
  return {flat:true,color,data};
}
